const Clear = () => (<br className="cb" />);

export default Clear;